import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { TracerRule } from '../models/TracerRule';

export class TracerRuleMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): TracerRule {
    const traceTypes = data.compatibleTraceTypes?.map((element: any) => element.traceType);

    return new TracerRule(data.number, data.title, data.category, data.ruleset, data.shortExplanation ?? '', new Set(traceTypes));
  }
}
